export const CAPTURE_MODES = ['photo', 'gif', 'boomerang', 'video'] as const

export const PAPER_SIZES = {
  '4x6': { width: 1200, height: 1800, label: '4 x 6 in (Portrait)' },
  '6x4': { width: 1800, height: 1200, label: '6 x 4 in (Landscape)' },
  '5x7': { width: 1500, height: 2100, label: '5 x 7 in' },
  '6x8': { width: 1800, height: 2400, label: '6 x 8 in' },
  '4x4': { width: 1200, height: 1200, label: '4 x 4 in' },
  'a4': { width: 2480, height: 3508, label: 'A4' },
  'custom': { width: 1200, height: 1800, label: 'Custom' },
} as const

export const DPI_PRESETS = [72, 150, 300, 600] as const

export const DEFAULT_REVIEW_TIME = 5
export const DEFAULT_DELAY_BEFORE_FIRST = 3
export const DEFAULT_DELAY_BETWEEN_POSES = 2
export const DEFAULT_POSE_COUNT = 3
export const DEFAULT_BOOTH_IDLE_TIMEOUT = 60
export const DEFAULT_GIF_FRAME_COUNT = 10
export const DEFAULT_GIF_FRAME_DELAY = 200
export const DEFAULT_BOOMERANG_DURATION = 3
export const DEFAULT_BOOMERANG_SPEED = 1
export const DEFAULT_VIDEO_MAX_DURATION = 15

export const SURVEY_FIELD_TYPES = [
  'text',
  'email',
  'phone',
  'checkbox',
  'dropdown',
  'signature',
  'gdpr',
] as const

export const TRIGGER_TYPES = ['auto', 'button', 'keyboard', 'qr', 'gesture'] as const
export const TRIGGER_ACTIONS = ['start', 'advance', 'retake', 'print', 'share', 'reset'] as const

export const WATERMARK_POSITIONS = [
  'top-left',
  'top-center',
  'top-right',
  'center-left',
  'center',
  'center-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
] as const

export const SCREEN_TYPES = ['welcome', 'capture', 'sharing'] as const

export const DEFAULT_SCHEMA_VERSION = '1.0.4'

export const LOCALES = ['en', 'nl'] as const
